import { DirectionProvider, Slider } from '@mantine/core';
import { ReactNode, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ActionIcon } from 'shared/ui';
import cls from './sidebar-slider.module.scss';

type SidebarSliderProps = {
	value: number;
	iconOn: ReactNode;
	iconOff: ReactNode;
	onChange: (value: number) => void;
};

export const SidebarSlider = ({ value, iconOn, iconOff, onChange }: SidebarSliderProps) => {
	const [previousValue, setPreviousValue] = useState(value || 1);

	const {
		i18n: { dir, language },
	} = useTranslation();

	const on = value > 0;

	return (
		<div className={cls.sidebarSlider}>
			<ActionIcon onClick={() => onChange(on ? 0 : previousValue)}>
				{on ? iconOn : iconOff}
			</ActionIcon>
			<DirectionProvider
				detectDirection={false}
				initialDirection={dir(language)}
			>
				<Slider
					dir={dir(language)}
					value={value}
					max={1}
					step={0.01}
					precision={2}
					className={cls.sidebarSliderSlider}
					onChange={onChange}
					onChangeEnd={(val) => val && setPreviousValue(val)}
				/>
			</DirectionProvider>
		</div>
	);
};
